module.exports = new __parcel__URL__("apple_login_button.ef92ae69.png").toString();